import { useEffect, useState } from "react";
import { pages } from "@microsoft/teams-js";
import {
  makeStyles,
  tokens,
  Text,
  Input,
  Field,
} from "@fluentui/react-components";

const TEAMS_APP_BASE = import.meta.env.VITE_APP_URL ?? "https://enque-teams.pages.dev";

const useStyles = makeStyles({
  root: {
    padding: tokens.spacingHorizontalXL,
    maxWidth: "520px",
  },
  heading: {
    marginBottom: tokens.spacingVerticalL,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalL,
  },
});

export default function TabConfigPage() {
  const styles = useStyles();
  const [workspaceId, setWorkspaceId] = useState("");
  const [teamId, setTeamId] = useState("");
  const [channelName, setChannelName] = useState("Ticket Queue");

  useEffect(() => {
    pages.config.registerOnSaveHandler((saveEvent) => {
      const qs = new URLSearchParams({ channelName });
      if (workspaceId) qs.set("workspaceId", workspaceId);
      if (teamId) qs.set("teamId", teamId);

      pages.config.setConfig({
        contentUrl: `${TEAMS_APP_BASE}/team-queue?${qs}`,
        entityId: `enque-queue-${workspaceId}-${teamId || "all"}`,
        suggestedDisplayName: channelName || "Ticket Queue",
      });

      saveEvent.notifySuccess();
    });
  // Run once on mount — save handler refs the latest state via closure
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Keep the Teams "Save" button enabled only when required fields are filled
  useEffect(() => {
    pages.config.setValidityState(workspaceId.trim().length > 0);
  }, [workspaceId]);

  return (
    <div className={styles.root}>
      <div className={styles.heading}>
        <Text size={500} weight="semibold">Configure Enque Tab</Text>
        <Text size={300} block style={{ marginTop: tokens.spacingVerticalXS, color: tokens.colorNeutralForeground3 }}>
          Connect a ticket queue to this Teams channel.
        </Text>
      </div>

      <div className={styles.form}>
        <Field
          label="Workspace ID"
          required
          hint="Copy from Enque → Settings → General."
        >
          <Input
            value={workspaceId}
            onChange={(_, d) => setWorkspaceId(d.value)}
            placeholder="workspace_abc123"
          />
        </Field>

        <Field
          label="Team filter"
          hint="Optional. Show only tickets assigned to a specific Enque team."
        >
          <Input
            value={teamId}
            onChange={(_, d) => setTeamId(d.value)}
            placeholder="team_xyz789"
          />
        </Field>

        <Field label="Tab display name">
          <Input
            value={channelName}
            onChange={(_, d) => setChannelName(d.value)}
            placeholder="Ticket Queue"
          />
        </Field>
      </div>
    </div>
  );
}
